import React from "react";
import AboutPolicySection from "../Components/leaders/AboutPolicySection";
import AboutPrLeaders from "../Components/leaders/AboutPrLeaders";
import ContactSection from "../Components/ContactSection";
import VisionSection from "../Components/VisionSection";
import PoliticsTimeline from "../Components/Aboutpranesh/PoliticsTimeline";
import CMTitleSection from "../Components/Aboutpranesh/CMTitleSection";
import PraneshInstagramSlider from "../Components/PraneshInstagramSlider";
import LatestEventsSection from "../Components/LatestEventsSection";
import VillageAchievements from "../Components/Aboutpranesh/villageAchievements";

export default function RegistrationPage() {
  return (
    <>
      <CMTitleSection />
      <AboutPrLeaders />
      <PoliticsTimeline />
      <AboutPolicySection />
      <VillageAchievements />
      <VisionSection />
      <LatestEventsSection />
      <PraneshInstagramSlider />
      <ContactSection />
    </>
  );
}
